import React, { useEffect, useRef, useState } from 'react';
import HoverableSelector from '../HoverableSelector/HoverableSelector';
import ScreenAssetSwap from './ScreenAssetSwap';
import { ScreenSwapContainer } from './ScreenSwap.styles';
import { IGatsbyImageData } from 'gatsby-plugin-image';
import useOnViewport from 'src/hooks/useOnViewport';
import useCurrentScale from 'src/hooks/useCurrentScale';
import useOnMobile from 'src/hooks/useOnMobile';

export interface IScreenSwapScreens {
  title: string;
  image?: IGatsbyImageData;
  mobileImage?: IGatsbyImageData;
  videoUrl?: string;
  posterUrl?: string;
}

interface ScreenSwapProps {
  screens: IScreenSwapScreens[];
  staticScale?: boolean;
}

const ScreenSwap = ({ screens, staticScale = false }: ScreenSwapProps): JSX.Element => {
  const [activeScreenIndex, setActiveScreenIndex] = useState(0);

  const containerRef = useRef<HTMLDivElement>(null);
  const isOnViewport = useOnViewport(containerRef);

  useEffect(() => {
    if (!isOnViewport) return;

    const timeout = setTimeout(() => {
      setActiveScreenIndex((activeScreenIndex + 1) % screens.length);
    }, 5000);

    return () => clearTimeout(timeout);
  }, [activeScreenIndex, isOnViewport]);

  const selectionItems = screens.map((screen, index) => ({
    text: screen.title,
    active: index === activeScreenIndex,
  }));

  const handleClickRightArrow = () => setActiveScreenIndex((prev) => (prev + 1) % screens.length);
  const handleClickLeftArrow = () => setActiveScreenIndex((prev) => (prev - 1 + screens.length) % screens.length);

  const isSmallerScreenSizeScale = useOnMobile(1600);
  const currentScale = staticScale && useCurrentScale(0.00009) * (isSmallerScreenSizeScale ? 1 : 100);

  return (
    <ScreenSwapContainer
      ref={containerRef}
      viewWidth={currentScale}
      staticScale={staticScale}
    >
      <HoverableSelector
        items={selectionItems}
        onItemClick={setActiveScreenIndex}
      />
      <ScreenAssetSwap
        onClickRightArrow={handleClickRightArrow}
        onClickLeftArrow={handleClickLeftArrow}
        screens={screens.map((screen, index) => ({
          ...screen,
          active: index === activeScreenIndex,
        }))}
      />
    </ScreenSwapContainer>
  );
};

export default ScreenSwap;
